import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { TextField } from '@emburse/ui-core';
export const CurrencyInput = ({ className, value = '', min, max, errorMessage, onChange }) => (_jsx(TextField, { label: "Budget", id: "budget-input", name: "budget-input", type: "number", fullWidth: true, required: true, helperText: errorMessage, error: Boolean(errorMessage), value: value && value.toString(), endAdornment: window.USER.currency_code, onChange: (e) => {
        if (!onChange) {
            return;
        }
        const newVal = e.target.value;
        // Only allow numbers and decimal point
        if (newVal === '' || /^\d+\.?\d{0,2}$/.test(newVal)) {
            onChange(Number(e.target.value));
        }
    }, onWheel: (e) => e.target.blur(), inputProps: { min: min || 0, max: max || Infinity, step: '0.01' } }));
